import { useEffect, useState } from 'react';
import { getArchivedArticleById } from '../api';
import ArticleView from './ArticleView';
import PageLayout from './PageLayout';
import PageMain from './ui/PageMain';
import ArticleBody from './ArticleBody';
import { useMemo } from 'react';
import { extractHeadings } from '../utils/articleHeadings';
import { useNavigate, useParams } from 'react-router-dom';
import { restoreArticleVersion } from '../api';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function ArchivedArticleView() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const canRestore = location.state?.from === 'archive';
    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const headings = useMemo(
        () => extractHeadings(article?.text ?? ''),
        [article?.text]
    );

    useEffect(() => {
        let cancelled = false;

        async function loadArticle() {
            setLoading(true);
            setError('');
            setArticle(null);

            try {
                const data = await getArchivedArticleById(id);

                // Support either a direct article or { article: ... } response.
                const result = data?.article ?? data;

                if (!result || result.article_id == null) {
                    throw new Error('Archived article not found');
                }

                if (!cancelled) {
                    setArticle(result);
                }
            } catch (err) {
                console.error('Error loading archived article:', err);

                if (!cancelled) {
                    setError('Die archivierte Version konnte nicht geladen werden.');
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        loadArticle();

        return () => {
            cancelled = true;
        };
    }, [id]);

    async function handleRestore() {
        const confirmed = window.confirm(
            t('articlesPage.confirmRestore')
        );

        if (!confirmed) return;

        try {
            await restoreArticleVersion(article.article_id);
            navigate('/articles');
        } catch (error) {
            console.error('Failed to restore article version:', error);
        }
    }

    return (
        <PageLayout showSearch showAiSearch>
            <PageMain className="article-page">
                {!loading && !error && article && (
                    <> <div className="article-list-actions">
                    </div>
                        <ArticleView
                            article={article}
                            isArchived
                            canRestore={canRestore}
                            onRestore={handleRestore}
                        >
                            <ArticleBody
                                articleText={article.text ?? ''}
                                headings={headings}
                                navigation={article.navigation}
                            />
                        </ArticleView>
                    </>
                )}
            </PageMain>
        </PageLayout>
    );
}
